export class EntityQuery {
    public dateSpanTerm: string;
    public searchTerm: string;
}


// WEBPACK FOOTER //
// ./src/app/client-core/dtos/entity.query.model.ts